module.exports = __webpack_public_path__ + "img/contents_title_sub05.bc05bc39.png";